export function initUsersData(phone, password) {
    return{
        phone: phone,
        password: password,
        isPhoneError: false,
        isPasswordError: false
    }
}